import * as React from 'react'
import {connect} from 'react-redux'
import type {RouteComponentProps} from 'react-router-dom'
import {withRouter} from 'react-router-dom'
import Spacer from '~/components/Spacer'
import {DSTextDiv} from '~/design-system/DSText'
import DSLink from '~/design-system/Link'
import {LoginAgnosticDashboardLayout} from '~/layouts/DashboardLayout'
import type {TNotSignedInYetReferrerPayload} from '~/pages/Auth/SignIn'
import type {ReduxState} from '~/redux/reducers/root'
import {isolateRouteComponentProps} from '~/routing/Route/utils'
import {staticURLs} from '~/routing/sitemap'

interface IReduxProps extends Pick<ReduxState, 'authenticatedPlayerState'> {}

interface INotFoundProps extends RouteComponentProps, IReduxProps {
  withoutDashboardFrame?: boolean
}

class NotFoundRouteComponent extends React.Component<INotFoundProps> {
  componentDidMount() {
    const {location} = this.props
    console.warn('NotFound rendered for path: ' + location.pathname)
  }

  render404Message() {
    const signinPayload: TNotSignedInYetReferrerPayload = {
      referrer: this.props.location,
    }

    return (
      <>
        <DSTextDiv size="h3">Not Found</DSTextDiv>
        <Spacer height="30px" />
        <DSTextDiv size="h2">Hmm...</DSTextDiv>
        <Spacer height="12px" />
        <DSTextDiv size="body-17">
          That page couldn't be found.
          {!this.props.authenticatedPlayerState.authenticatedPlayer && (
            <>
              {' '}
              Do you need to{' '}
              <DSLink
                underline
                to={{pathname: staticURLs.auth.signin, state: signinPayload}}
              >
                sign in
              </DSLink>
              ?
            </>
          )}
        </DSTextDiv>
      </>
    )
  }

  render() {
    if (this.props.withoutDashboardFrame) {
      return this.render404Message()
    }

    return (
      <LoginAgnosticDashboardLayout
        {...isolateRouteComponentProps(this.props)}
        authenticatedPlayer={this.props.authenticatedPlayerState.authenticatedPlayer}
      >
        {this.render404Message()}
      </LoginAgnosticDashboardLayout>
    )
  }
}

const mapStateToProps = (state: ReduxState): IReduxProps => ({
  authenticatedPlayerState: state.authenticatedPlayerState,
})

export default withRouter(connect(mapStateToProps)(NotFoundRouteComponent))
